import React, { forwardRef } from 'react';
import Box, { type BoxProps } from '../../atoms/Box';

const defaultPadding = 2.5;

export type CardProps = BoxProps;

const baseStyles = {
  backgroundColor: 'background.paper',
  borderRadius: 1,
  border: '1px solid',
  borderColor: 'divider',
  p: defaultPadding,
};

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, sx, ...props }, ref) => {
    // The array form lets callers pass an object or a theme callback.
    const sxList = Array.isArray(sx) ? sx : sx ? [sx] : [];
    return (
      <Box ref={ref} sx={[baseStyles, ...sxList]} {...props}>
        {children}
      </Box>
    );
  }
);

Card.displayName = 'Card';

export default Card;
